import { useMemo } from 'react'

import type { CSSProperties } from 'react'
import type { MarginProps } from './Margin.props'

const Margin = ({ m, mt, mr, mb, ml, mx, my, children, style, ...props }: MarginProps) => {
  const marginStyles = useMemo(() => {
    const updatedStyles: CSSProperties = {}

    if (m) {
      updatedStyles.margin = m
    }

    if (mt) {
      updatedStyles.marginTop = mt
    }
    if (mr) {
      updatedStyles.marginRight = mr
    }
    if (mb) {
      updatedStyles.marginBottom = mb
    }
    if (ml) {
      updatedStyles.marginLeft = ml
    }

    if (mx) {
      updatedStyles.marginLeft = mx
      updatedStyles.marginRight = mx
    }

    if (my) {
      updatedStyles.marginTop = my
      updatedStyles.marginBottom = my
    }

    return updatedStyles
  }, [m, mt, mr, mb, ml, mx, my])

  return (
    <div style={{ ...style, ...marginStyles }} {...props}>
      {children}
    </div>
  )
}

export { Margin }
